﻿import projectService from "../../project/services/project-service";
import { Enums } from "../helper/enums";
import { clientEntity } from "../model/entity/client-entity";
import { clientLocationEntity } from "../model/entity/client-location-entity";
import { contactEntity } from "../model/entity/contact-entity";
import { contactTagEntity } from "../model/entity/contact-tag-entity";
import { contactViewingEntity } from "../model/entity/contact-viewing-entity";
import { customStatusEntity } from "../model/entity/custom-status-entity";
import { emailConfigurationEntity } from "../model/entity/email-configuration-list-entity";
import { technicianEntity } from "../model/entity/technician-entity";
import { technicianGroupEntity } from "../model/entity/technician-group-entity";
import { ticketSettingEntity } from "../model/entity/ticket-setting-entity";
import { projectTypeEntity } from "../model/project/project-type-entity";
import ClientService from "../services/client-api-service";
import contactService from "../services/contact-service";
import ServiceProviderServices from "../services/service-provider-service";
import TechnicianServices from "../services/technician-service";
import ticketService from "../services/ticket-service";
import type { entityProcessDictionary } from "./signalr-process-config";

export const EntityEnumConfig: entityProcessDictionary = {
  [Enums.EntitySyncManager[Enums.EntitySyncManager.FillClients]]: {
    promise: ClientService.getClients,
    entity: clientEntity,
    methodName: "fillClients",
    hasAccess: () => true,
  },
  [Enums.EntitySyncManager[Enums.EntitySyncManager.FillTickets]]: {
    promise: ticketService.GetAllTickets,
    entity: null,
    methodName: "fillTickets",
    hasAccess: () => true,
  },
  [Enums.EntitySyncManager[Enums.EntitySyncManager.FillClientlocations]]: {
    promise: ClientService.getAllClientLocations,
    entity: clientLocationEntity,
    methodName: "fillClientlocations",
    hasAccess: () => true,
  },
  [Enums.EntitySyncManager[Enums.EntitySyncManager.FillTechnicians]]: {
    promise: TechnicianServices.getTechnicianList,
    entity: technicianEntity,
    methodName: "fillTechnicians",
    hasAccess: () => true,
  },
  [Enums.EntitySyncManager[Enums.EntitySyncManager.GetContactsOfOtherGroups]]: {
    promise: contactService.getContactsOfOtherGroups,
    entity: contactViewingEntity,
    methodName: "GetContactsOfOtherGroups",
    hasAccess: () => true,
  },
  [Enums.EntitySyncManager[Enums.EntitySyncManager.FillContacts]]: {
    promise: contactService.getContacts,
    entity: contactEntity,
    methodName: "fillContacts",
    hasAccess: () => true,
  },
  [Enums.EntitySyncManager[Enums.EntitySyncManager.GetTechnicianByTick]]: {
    promise: TechnicianServices.getTechnicianByTick,
    entity: technicianEntity,
    methodName: "getTechnicianByTick",
    hasAccess: () => true,
  },
  [Enums.EntitySyncManager[Enums.EntitySyncManager.CheckClientTick]]: {
    promise: ClientService.getClientByTick,
    entity: clientEntity,
    methodName: "checkClientTick",
    hasAccess: () => true,
  },
  [Enums.EntitySyncManager[Enums.EntitySyncManager.CheckTicketTick]]: {
    promise: ticketService.getTicketsByTick,
    entity: null,
    methodName: "checkTicketTick",
    hasAccess: () => true,
  },
  [Enums.EntitySyncManager[Enums.EntitySyncManager.CheckContactTick]]: {
    promise: contactService.getContactByTick,
    entity: contactViewingEntity,
    methodName: "checkContactTick",
    hasAccess: () => true,
  },
  [Enums.EntitySyncManager[Enums.EntitySyncManager.FillTechnicianGroup]]: {
    promise: TechnicianServices.getTechnicianGroupList,
    entity: technicianGroupEntity,
    methodName: "fillTechnicianGroup",
    hasAccess: () => true,
  },
  [Enums.EntitySyncManager[Enums.EntitySyncManager.GetEmailConfigurations]]: {
    promise: ServiceProviderServices.getEmailConfigurationListByServiceProvider,
    entity: emailConfigurationEntity,
    methodName: "getEmailConfigurations",
    hasAccess: () => true,
  },
  [Enums.EntitySyncManager[Enums.EntitySyncManager.FillMSPTicketSettings]]: {
    promise: ServiceProviderServices.getTicketReopenThreshold,
    entity: ticketSettingEntity,
    methodName: "fillMSPTicketSettings",
    hasAccess: () => true,
  },
  [Enums.EntitySyncManager[Enums.EntitySyncManager.FillContactTags]]: {
    promise: contactService.getContactTagList,
    entity: contactTagEntity,
    methodName: "FillContactTags",
    hasAccess: () => true,
  },
  [Enums.EntitySyncManager[Enums.EntitySyncManager.FillCustomStatus]]: {
    promise: ticketService.getCustomStatus,
    entity: customStatusEntity,
    methodName: "fillCustomStatus",
    hasAccess: () => true,
  },
  [Enums.EntitySyncManager[Enums.EntitySyncManager.FillProjectTypes]]: {
    promise: projectService.getProjectTypeList,
    entity: projectTypeEntity,
    methodName: "fillProjectTypes",
    hasAccess: () => true,
  },
};
